let inMemoryToken = '';

export const tokenStorage = {
  set(token) {
    inMemoryToken = token || '';
  },
  get() {
    return inMemoryToken;
  },
  clear() {
    inMemoryToken = '';
  }
};
